import { FunctionComponent, useState } from 'react';
import { Form, Input } from 'antd';
import CompanyService from '../../../services/Admin/Company';
import Roles from './../Company/Roles';
import ModalWrapper from '../../../components/wrapper/ModalWrapper';

interface Props {
    onFinish: () => void;
    onCancel: () => void;
    companyId: string;
    isModalOpen: boolean;
}

const AddUser: FunctionComponent<Props> = (props) => {
    const [form] = Form.useForm();
    const [roleId, setRoleId] = useState<number>(2);

    const SaveUser = async () => {
        try {
            const values = await form.validateFields();
            await CompanyService.addUserToCompany(props.companyId, {
                firstName: values.firstName,
                lastName: values.lastName,
                displayName: values.displayName,
                email: values.email,
                roleId,
            });
            form.resetFields();
            setRoleId(2);
            props.onFinish();
        } catch (_) {
            // validation error — form shows inline messages
        }
    };

    const Cleanup = () => {
        form.resetFields();
        setRoleId(2);
        props.onCancel();
    };

    return (
        <ModalWrapper
            isCloseModalShown={true}
            closeModalHandler={Cleanup}
            isFooterShown={true}
            primaryButtonText="save"
            primaryButtonHandler={SaveUser}
            title="Add user"
            isModalOpened={props.isModalOpen}
        >
            <Form
                form={form}
                name="add-user"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
            >
                <Form.Item
                    label="First Name"
                    name="firstName"
                    style={{ marginTop: 2 }}
                    rules={[{ required: true, message: 'Please input first name.' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Last Name"
                    name="lastName"
                    style={{ marginTop: 2 }}
                    rules={[{ required: true, message: 'Please input last name.' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Display Name"
                    name="displayName"
                    style={{ marginTop: 2 }}
                    rules={[{ required: true, message: 'Please input display name.' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, type: 'email', message: 'The input is not valid E-mail!' }]}
                >
                    <Input />
                </Form.Item>
                <Form.Item label="Role">
                    <Roles onSelected={(v) => setRoleId(v)} />
                </Form.Item>
            </Form>
        </ModalWrapper>
    );
};

export default AddUser;
